import gql from 'graphql-tag';

// QUERIES

export const POSTS_FOR_ZONE = gql`
  query PostsForZone($zoneId: ObjectId!, $filter: [PostValidity!]) {
    postsForZone(zoneId: $zoneId, filter: $filter) {
      _id
      zoneId
      title
      text
      imageURL
      imageFullURL
      buttonLink
      buttonLabel
      validFrom
      validTo
      validityStatus
    }
  }
`;

// MUTATIONS

export const CREATE_POST = gql`
  mutation CreatePost(
    $zoneId: ObjectId!
    $validFrom: DateTime!
    $validTo: DateTime!
    $title: String
    $text: String
    $imageURL: String
    $buttonLink: String
    $buttonLabel: String
  ) {
    createPost(
      zoneId: $zoneId
      validFrom: $validFrom
      validTo: $validTo
      title: $title
      text: $text
      imageURL: $imageURL
      buttonLink: $buttonLink
      buttonLabel: $buttonLabel
    ) {
      _id
    }
  }
`;

export const UPDATE_POST = gql`
  mutation UpdatePost(
    $_id: ObjectId!
    $validFrom: DateTime
    $validTo: DateTime
    $title: String
    $text: String
    $imageURL: String
    $buttonLink: String
    $buttonLabel: String
  ) {
    updatePost(
      _id: $_id
      validFrom: $validFrom
      validTo: $validTo
      title: $title
      text: $text
      imageURL: $imageURL
      buttonLink: $buttonLink
      buttonLabel: $buttonLabel
    ) {
      _id
    }
  }
`;

export const DELETE_POST = gql`
  mutation DeletePost($_id: ObjectId!) {
    deletePost(_id: $_id) {
      _id
    }
  }
`;
